import { render, staticRenderFns } from "./newPathAni.vue?vue&type=template&id=553d92b0&scoped=true&"
import script from "./newPathAni.vue?vue&type=script&lang=js&"
export * from "./newPathAni.vue?vue&type=script&lang=js&"
import style0 from "./newPathAni.vue?vue&type=style&index=0&id=553d92b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553d92b0",
  null
  
)

export default component.exports